import { Component, OnInit, Inject } from '@angular/core';
import { ResumenEvaluacionModel } from '../../../../../model/Etapas.model'; 
import { apiService } from '../../../../../service/api.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CapacitacionJardinComponent } from '../../capacitacion-jardin/capacitacion-jardin.component';
@Component({
  selector: 'app-modal-resumen-evaluacion',
  templateUrl: './modal-resumen-evaluacion.component.html',
  styleUrls: ['./modal-resumen-evaluacion.component.css'],
  providers: []
})
export class ModalResumenEvaluacionComponent implements OnInit {
  
  evaluacion = new ResumenEvaluacionModel();
  constructor(
    public api:apiService,
    public dialogRef: MatDialogRef<ModalResumenEvaluacionComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  cerrar() {
    this.dialogRef.close();

    
  }

  ngOnInit(): void {
    this.evaluacion = this.data;
    
  }

}
